import { IDocumentService, IPromise, IQResolveReject, IQService, IRootScopeService, IWindowService } from 'angular';

export class GmcRecaptchaService {
  static $inject = [
    '$window',
    '$document',
    '$q',
    '$rootScope'
  ];
  config: ReCaptchaV2.Parameters;
  onLoadFunctionName: string;
  recaptchaLoaded: IPromise<any>;
  private recaptcha: ReCaptchaV2.ReCaptcha;
  private inited = false;
  private resolve: IQResolveReject<any>;
  private reject: IQResolveReject<any>;
  private instances: { [widgetId: number]: HTMLElement } = {};

  constructor( private $window: IWindowService,
               private $document: IDocumentService,
               private $q: IQService,
               private $rootScope: IRootScopeService ) {
  }

  create( element, conf: ReCaptchaV2.Parameters ): IPromise<number> {
    if ( !this.inited ) {
      this.init();
    }
    return this.recaptchaLoaded
      .then(() => {
        const params = { ...this.config, ...conf };
        params.sitekey = this.config.sitekey;
        const widgetId = this.recaptcha.render(element[ 0 ], params);
        this.instances[ widgetId ] = element[ 0 ];
        return widgetId;
      });
  }

  reload( widgetId: number ) {
    this.recaptcha.reset(widgetId);
  }

  getResponse( widgetId: number ): string {
    return this.recaptcha.getResponse(widgetId);
  }

  getInstance( widgetId: number ) {
    return this.instances[ widgetId ];
  }

  deleteWidget( widgetId: number ) {
    this.$rootScope.$broadcast('reCaptchaReset', widgetId);
    delete this.instances[ widgetId ];
  }

  private init() {
    this.inited = true;
    this.recaptchaLoaded = this.$q(( resolve, reject ) => {
      this.resolve = resolve;
      this.reject = reject;
    });
    this.$window[ this.onLoadFunctionName ] = () => {
      this.recaptcha = this.$window[ 'grecaptcha' ];
      this.resolve();
    };
    this.insertScript();
  }

  private insertScript() {
    if ( this.$window.grecaptcha ) {
      throw new Error('Grecaptcha is already defined');
    } else {
      const script = this.$window.document.createElement('script');
      script.async = true;
      script.defer = true;
      script.src = `https://www.google.com/recaptcha/api.js?onload=${this.onLoadFunctionName}&render=explicit`;
      this.$document.find('body').append(script);
    }
  }
}



// WEBPACK FOOTER //
// ./app/shared/directives/gmc-recaptcha/gmc-recaptcha.service.ts